export const explorerAccountsKeys = {
  base: ["/explorer-accounts"],
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  total: (params: Record<string, any>) => [...explorerAccountsKeys.base, "/total", params],
};
